import { connect } from 'react-redux';
import { getCdSuccess, getCdError } from 'actions';
import $ from 'jquery';
import Detail from 'components/cd/Detail';

const mapStateToProps = (state) => ({
	data: state.getCd.situation,
})

const mapDispatchToProps = (dispatch) => ({
	getCd: () => (
		$.ajax({
			url: '/json/cd.json',
			dataType: "json"
		}).then((data) => {
			dispatch(getCdSuccess(data));
		}, () => {
			console.log('error');
			dispatch(getCdError());
		})
	)
})

const CdSituationContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
)(Detail)

export default CdSituationContainer



// WEBPACK FOOTER //
// src/containers/cd/Situation.js